// extracted by mini-css-extract-plugin
export default {"editor":"styles_editor__NoPGl","buttonBlueSendMessage":"styles_buttonBlueSendMessage__Ixxs9"};